import { Routes, Route, Navigate } from "react-router-dom";
import { PrivateRoute } from "PrivateRoute";
import AuthLayout from "layouts/auth";
import SuperUser from "layouts/superuser";
import { useEffect } from "react";

function getFaviconElement(): HTMLLinkElement | null {
  return document.getElementById("favicon") as HTMLLinkElement | null;
}

const App = () => {
  useEffect(() => {
    const storedFavicon = localStorage.getItem("favicon");
    const storedTitle = localStorage.getItem("title");

    if (storedFavicon) {
      const favicon = getFaviconElement();
      favicon.href = storedFavicon;
    }

    if (storedTitle) {
      document.title = storedTitle;
    }
  }, []);
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="superuser/*"
        element={
          <PrivateRoute>
            <SuperUser />
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
};

export default App;
